"use client";

interface Stage {
  id: string;
  name: string;
  description?: string | null;
}

interface Performer {
  id: string;
  name: string;
  bio: string | null;
  imageUrl: string | null;
  socialLinks: Record<string, string> | null;
  role: string | null;
  performanceStartTime: string | null;
  performanceEndTime: string | null;
  isHeadliner: boolean;
  stageId: string | null;
}

interface EventStagesCardProps {
  stages: Stage[];
  sortedPerformers: Performer[];
}

export function EventStagesCard({ stages, sortedPerformers }: EventStagesCardProps) {
  if (stages.length <= 1) return null;

  return (
    <div className="bg-[#0c0c18] border border-white/[0.08] rounded-[20px] p-7 transition-colors hover:border-white/[0.12]">
      <div className="flex items-center justify-between mb-5">
        <span className="text-[11px] uppercase tracking-[0.1em] font-semibold text-white/50">Stages</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {stages.map((stage) => {
          const count = sortedPerformers.filter((p) => p.stageId === stage.id).length;
          return (
            <span key={stage.id} className="px-3.5 py-1.5 rounded-full bg-white/[0.04] border border-white/[0.08] text-white/60 text-xs font-medium">
              {stage.name}{count > 0 ? ` (${count})` : ""}
            </span>
          );
        })}
      </div>
      {stages.some((s) => s.description) ? (
        <div className="mt-4 space-y-3">
          {stages.filter((s) => s.description).map((stage) => (
            <div key={stage.id} className="p-4 rounded-[14px] bg-white/[0.04] border border-white/[0.08]">
              <p className="font-medium text-sm text-white">{stage.name}</p>
              <p className="mt-1 text-xs text-white/50 line-clamp-2">{stage.description}</p>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
